var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "portfolio-grid" },
    [
      _c("KendoGridColumnsEditorDialog", {
        attrs: {
          propOpened: _vm.columnsEditorDialogOpened,
          propGrid: _vm.grid,
        },
        on: { "close-dialog": _vm.closeColumnsEditor },
      }),
      _vm._v(" "),
      _c("div", { attrs: { id: "pbGrid" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }